import { useNavigate } from 'react-router-dom';

import { capitalizeFirstLetter, formatDateTime } from '../../../utils';
import { ComponentContext } from '../../../contexts/ComponentContext';
import { ComponentBadges } from '../../ComponentBadges/ComponentBadges';
import { Badge } from '../../Badge/Badge';
import { UserInitials } from '../../UserInitials/UserInitials';

import type { ComponentResponse, UserResponse } from '../../../types';

import styles from './ComponentRow.module.scss';

type Props = {
  component: ComponentResponse;
  user?: UserResponse;
};

function ComponentRow({ component, user }: Props) {
  const navigate = useNavigate();

  const { id, type, header, sharedName } = component;

  return (
    <ComponentContext.Provider value={{ component }}>
      <tr onClick={() => navigate(`/components/${id}`)} className={styles.row}>
        <td>{sharedName}</td>
        <td>
          <div className={styles.componentDetails}>
            <span className={styles.componentType}>
              {capitalizeFirstLetter(type)}
            </span>
            {header && (
              <span className={styles.componentHeader}>
                &quot;{header}&quot;
              </span>
            )}
            <ComponentBadges component={component} small />
            {component.options && component.options.usePageTaxonomy && (
              <Badge small>«page taxonomy»</Badge>
            )}
          </div>
        </td>
        <td>
          <div className={styles.updated}>
            {component.updatedAt != null && formatDateTime(component.updatedAt)}
            {user && <UserInitials user={user} className={styles.initials} />}
          </div>
        </td>
      </tr>
    </ComponentContext.Provider>
  );
}

export { ComponentRow };
